import { React, useEffect, useState } from "react";
import styled from "styled-components";
import { Accordion, CheckBox, DateRange, Input2 } from "components";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { circular_types } from "utils";

import "rc-slider/assets/index.css";
import "./style.scss";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { getRetailerAutocompleteApi } from "api";
import { Button, Input, Modal } from "antd";
import { SearchByMultipleRetailer } from "./SearchByMultipleRetailer";

const stages = [
  { label: "Accepted", name: "ACCEPTED" },
  { label: "Section Processing", name: "SECTION_PROCESSING" },
  { label: "Page Processing", name: "PAGE_PROCESSING" },
  { label: "Product Processing", name: "PRODUCT_PROCESSING" },
  { label: "Offer Processing", name: "OFFER_PROCESSING" },
  //{ label: "Reassembly", name: "REASSEMBLY" },
  { label: "Complete", name: "COMPLETE" }
];

export const FilterSectionModal = ({ filter_name, filter_value, isOpen, onOk, onCancel, tiers, mode }) => {

  const [stage, setStage] = useState([]);
  const [tier, setTier] = useState([]);
  const [circType, setCircType] = useState([]);
  const [circDateFrom, setCircDateFrom] = useState(null);
  const [circDateTo, setCircDateTo] = useState(null);
  const [creationDateFrom, setCreationDateFrom] = useState(null);
  const [creationDateTo, setCreationDateTo] = useState(null);
  const [adBlocksCount, setAdBlocksCount] = useState(null);
  const [activeRetailers, setActiveRetailers] = useState(null)
  const [retailerIds, setRetailerIds] = useState([]);
  const [filterName, setFilterName] = useState(filter_name || '');
  const [isLoading, setIsLoading] = useState(false);

  const handleOk = async() => {
    setIsLoading(true)
      const filters = {
      retailerIds: retailerIds,
      stage: stage,
      tier: tier,
      circType: circType,
      circDateFrom: circDateFrom,
      circDateTo: circDateTo,
      creationDateFrom: creationDateFrom,
      creationDateTo: creationDateTo,
      adBlocksCount: adBlocksCount,
      activeRetailers: activeRetailers
    }

    await onOk(filterName, filters);
    setIsLoading(false)
  }

  const init = async () => {
    if (mode === 'update' && filter_value) {
      setFilterName(filter_name || '');
      setRetailerIds(filter_value.retailerIds || []);
      setStage(filter_value.stage || []);
      setTier(filter_value.tier || []);
      setCircType(filter_value.circType || []);
      setCircDateFrom(filter_value.circDateFrom ? new Date(filter_value.circDateFrom) : null);
      setCircDateTo(filter_value.circDateTo ? new Date(filter_value.circDateTo) : null);
      setCreationDateFrom(filter_value.creationDateFrom ? new Date(filter_value.creationDateFrom) : null);
      setCreationDateTo(filter_value.creationDateTo ? new Date(filter_value.creationDateTo) : null);
      setAdBlocksCount(filter_value.adBlocksCount || null);
      setActiveRetailers(filter_value.activeRetailers || false);
    }
    else {
      clearModal();
    }
  }

    const clearModal = () => {
      setFilterName('')
      setRetailerIds([]);
      setStage([]);
      setTier([]);
      setCircType([]);
      setCircDateFrom(null);
      setCircDateTo(null);
      setCreationDateFrom(null);
      setCreationDateTo(null);
      setAdBlocksCount(null);
      setActiveRetailers(false);
    }

   useEffect(() => {
        init();
        return () => {};
      }, [isOpen]);

  const handleSelectAll = (filterType, selectedItems, allItems) => {
    if (selectedItems.length === allItems.length) {
      allItems = [];
    }
    if (filterType === "tier")
      setTier(allItems.map(item => item.ext_id));
    else if (filterType === "stage")
      setStage(allItems.map(item => item.name));
    else if (filterType === 'circType')
      setCircType(allItems.map(item => item.title))

  };

  return (
    <Modal key='filter-modal'
      title={mode === 'create' ? "Create Filter" : "Update Filter"}
      maskClosable={false} // Prevents closing on mask click
      keyboard={false}     // Prevents closing on Esc key
      open={isOpen}
      onOk={handleOk}
      onCancel={onCancel}
      footer={[
          <Button key="back" onClick={onCancel}>Cancel</Button>,
          <Button key="ok" variant="solid" color="primary" loading={isLoading} onClick={handleOk}>
            Save
          </Button>,
        ]}
      style={{
        top: 0,
        right: 0,
        position: 'centered',
      }}
    >
      <Input key='fname' placeholder="Filter Name" value={filterName} onChange={(e) => setFilterName(e.target.value)} style={{margin:'12px 12px 12px 23px', width : '300px'}}/>
      <SearchByMultipleRetailer func={getRetailerAutocompleteApi} retailerIds={retailerIds} styles={{ width: '325px' }} onSelect={(retailer_ids) => setRetailerIds(retailer_ids)}
      />
      <FilterContainer>
        <AccordionSection>
              <div className="title">Filters</div>
              <Accordion
                title="Circulation Date"
                open={circDateFrom || circDateTo}
              >
                <div className="py-3">
                  <DateRange
                    open={circDateFrom || circDateTo}
                    startDate={circDateFrom}
                    endDate={circDateTo}
                    onChange={(dates) => {
                        setCircDateFrom(dates[0]);
                        setCircDateTo(dates[1]);
                    }}
                    onClear={(dates) => {
                      setCircDateFrom(undefined);
                      setCircDateTo(undefined);
                    }}
                  />
                </div>
              </Accordion>
              <Accordion
                title="Created Date"
                open={creationDateFrom || creationDateTo}
              >
                <div className="py-3">
                  <DateRange
                    open={creationDateFrom || creationDateTo}
                    startDate={creationDateFrom}
                    endDate={creationDateTo}
                    onChange={(dates) => {
                      setCreationDateFrom(dates[0]);
                      setCreationDateTo(dates[1]);
                    }}
                    onClear={(dates) => {
                      setCreationDateFrom(undefined);
                      setCreationDateTo(undefined);
                    }}
                  />
                </div>
              </Accordion>
              <Accordion
                title="Stages"
                desc=""
                className="mb-3"
                open={stage && stage?.length > 0}
              >
                <div className="m-3">
                  <CheckBox
                    value={stage.length === stages.length}
                    onChange={() => handleSelectAll('stage', stage, stages)}
                  >
                    <span className="font-weight-600">Select All</span>
                  </CheckBox>
                </div>
                {stages.map(({ label, name }) => (
                  <div key={name} className="m-3">
                    <CheckBox
                      value={(stage || []).includes(name)}
                      onChange={() => setStage(prev => prev.includes(name) ? prev.filter(item => item !== name) : [...prev, name])}
                    >
                      {label}
                    </CheckBox>
                  </div>
                ))}
              </Accordion>


              <Accordion
                title="Tiers"
                desc=""
                className="mb-3"
                open={tier && tier?.length > 0}
              >
                <div className="m-3">
                  <CheckBox
                    value={tier.length === tiers.length}
                    onChange={() => handleSelectAll('tier', tier, tiers)}
                  >
                    <span className="font-weight-600">Select All</span>
                  </CheckBox>
                </div>
                {tiers.map(({ ext_id }) => (
                  <div key={ext_id} className="m-3">
                    <CheckBox
                      value={(tier || []).includes(ext_id)}
                      onChange={() => setTier(prev => prev.includes(ext_id) ? prev.filter(item => item !== ext_id) : [...prev, ext_id])}
                    >
                      {ext_id}
                    </CheckBox>
                  </div>
                ))}
              </Accordion>

              <Accordion
                title="Circular Types"
                desc=""
                className="mb-3"
                open={circType && circType?.length > 0}
              >
                <div className="m-3">
                  <CheckBox
                    value={circType.length === circular_types.length}
                    onChange={() => handleSelectAll('circType', circType, circular_types)}
                  >
                    <span className="font-weight-600">Select All</span>
                  </CheckBox>
                </div>
                {circular_types.map(({ title }) => (
                  <div key={title} className="m-3">
                    <CheckBox
                      value={(circType || []).includes(title)}
                      onChange={() => setCircType(prev => prev.includes(title) ? prev.filter(item => item !== title) : [...prev, title])}
                    >
                      {title}
                    </CheckBox>
                  </div>
                ))}
              </Accordion>

              <Input2 placeholder="AdBlocks Count" className="mb-3" type="number" min="0" value={adBlocksCount ? adBlocksCount : ""}
                onKeyPress={e => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()}
                onChange={(e) => setAdBlocksCount(e)}
              />

              <CheckBox
                value={activeRetailers}
                onChange={(e) => setActiveRetailers(e)}
              >
                Active Circulars
              </CheckBox>        
        </AccordionSection>
      </FilterContainer>
    </Modal>
  );
};


const FilterContainer = styled.div`
  overflow: auto;
  border-bottom:2px solid ${(props) => props.theme.palette.background};

  input
  {
    font-size:14px;
  }

  
`;

const AccordionSection = styled.div`
  margin: 12px 12px 12px 24px;
  padding-right: 10px;
  min-width: 240px;
  ::-webkit-scrollbar {
    width: 10px;
    background: ${(props) => props.theme.palette.background};
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.palette.background};
    border: 1px solid ${(props) => props.theme.palette.itemsHover};
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.palette.itemsHover};
    cursor: pointer;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
    cursor: pointer;
  }

  .title {
    color:white;
    font-size:12px;
    border-bottom: 1px solid ${(props) => props.theme.palette.itemsHover};
    text-transform:uppercase;
  }
`;


